/**
 * Quick Order JavaScript - Enhanced Version
 * File: assets/quick-order.js
 */

document.addEventListener('DOMContentLoaded', function() {
  // Element references
  const searchInput = document.getElementById('product-search');
  const tabButtons = document.querySelectorAll('.tab-button');
  const sectionContents = document.querySelectorAll('.section-content');
  const clearAllBtn = document.getElementById('clear-all');
  const addSelectedBtn = document.getElementById('add-selected');
  const bulkForm = document.getElementById('bulk-add-form');
  const visibleCountSpan = document.getElementById('visible-count');
  const totalValueSpan = document.getElementById('total-value');
  const selectedCountSpan = document.getElementById('selected-count');

  let currentSection = 'all';

    // Alternative function to open cart drawer
  function openCartDrawer(state) {
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      // Fetch cart with sections for the drawer
      fetch(`${window.themeVariables.routes.cartUrl}.js`, {cache: 'reload'})
        .then(response => response.json())
        .then(data => {
          // Create cart refresh event with sections data
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {detail: {cart: data}}));

          if(data["items"][0]) {
            if(state) {
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  openMiniCart: true
                }
              }));
            } else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',  { bubbles: true }));
            }
          }
        });
    }
  }

  // Tab switching functionality
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const section = this.dataset.section;
      
      tabButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      
      sectionContents.forEach(content => {
        if (content.dataset.section === section) {
          content.classList.add('active');
        } else {
          content.classList.remove('active');
        }
      });
      
      currentSection = section;
      filterAndSortProducts();
    });
  });

  // Search and filter functionality
  function filterAndSortProducts() {
    const searchTerm = searchInput.value.toLowerCase();
    
    const activeContent = document.querySelector(`.section-content[data-section="${currentSection}"]`);
    if (!activeContent) return;
    
    const productRows = activeContent.querySelectorAll('.product-row');
    let visibleRows = [];

    productRows.forEach(row => {
      const title = row.dataset.title || '';
      const sku = row.dataset.sku || '';
      
      const matchesSearch = title.includes(searchTerm) || sku.includes(searchTerm);
      
      if (matchesSearch) {
        row.style.display = '';
        visibleRows.push(row);
      } else {
        row.style.display = 'none';
      }
    });

    visibleCountSpan.textContent = visibleRows.length;
   
  }
// Replace the checkProductAvailability function in quick-order.js with this version:

function checkProductAvailability(row) {
  const quantityInput = row.querySelector('.quantity-input');
  const addButton = row.querySelector('.individual-add-btn');
  const stockBadge = row.querySelector('.stock-badge');
  const variantSelect = row.querySelector('.variant-select');
  
  if (!quantityInput || !addButton) {
    console.warn('Missing required elements in row');
    return;
  }
  
  // Get the selected variant's inventory policy
  let inventoryPolicy = 'deny'; // default
  let stockQuantity = 0;
  
  if (variantSelect) {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    inventoryPolicy = selectedOption.dataset.inventoryPolicy || 'deny';
    stockQuantity = parseInt(selectedOption.dataset.stock) || 0;
  } else {
    // For single variant products, check the stock badge
    const isOutOfStockBadge = stockBadge && stockBadge.classList.contains('out-of-stock');
    
    if (!isOutOfStockBadge) {
      // If not showing out of stock badge, assume it's available
      inventoryPolicy = 'continue';
    }
  }
  
  const currentQuantity = parseInt(quantityInput.value) || 1;
  const variantId = quantityInput.dataset.variantId;
  
  console.log('Checking availability for row:', {
    variantId,
    stockQuantity,
    inventoryPolicy,
    currentQuantity,
    stockBadgeClasses: stockBadge ? stockBadge.className : 'no badge'
  });
  
  // Determine if truly out of stock (no stock AND policy is deny)
  const isTrulyOutOfStock = stockQuantity <= 0 && inventoryPolicy !== 'continue';
  
  // Handle truly out of stock (no inventory AND policy deny)
  if (isTrulyOutOfStock) {
    console.log('Setting as out of stock (disabled) for variant:', variantId);
    quantityInput.disabled = true;
    quantityInput.value = 0;
    addButton.disabled = true;
    addButton.textContent = 'Out of Stock';
    addButton.classList.add('out-of-stock');
    row.classList.add('out-of-stock');
  } 
  // Handle everything else as available (in stock OR backorder allowed)
  else {
    console.log('Setting as available (enabled) for variant:', variantId);
    quantityInput.disabled = false;
    addButton.classList.remove('out-of-stock');
    row.classList.remove('out-of-stock');
    
    // Ensure minimum quantity is 1
    if (currentQuantity < 1) {
      quantityInput.value = 1;
    }
    
    // Button is always enabled for available items
    addButton.disabled = false;
    addButton.textContent = 'Add';
  }
  
  // Also disable/enable the quantity buttons
  const qtyButtons = row.querySelectorAll('.qty-btn');
  qtyButtons.forEach(btn => {
    btn.disabled = quantityInput.disabled;
  });
  
  console.log('Final state:', {
    quantityInputDisabled: quantityInput.disabled,
    addButtonDisabled: addButton.disabled,
    addButtonText: addButton.textContent,
    rowClasses: row.className,
    finalQuantity: quantityInput.value
  });
}

  // Initialize all product rows on page load
  function initializeProductRows() {
    console.log('Initializing product rows...');
    
    // Add a small delay to ensure DOM is fully ready
    setTimeout(() => {
      document.querySelectorAll('.product-row').forEach((row, index) => {
        console.log(`Initializing row ${index + 1}:`);
        
        // Force update the stock status based on current variant selection
        const variantSelect = row.querySelector('.variant-select');
        if (variantSelect) {
          // Trigger change event to ensure proper initialization
          const changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true,
          });
          variantSelect.dispatchEvent(changeEvent);
        } else {
          // For single variant products, just check availability
          checkProductAvailability(row);
        }
      });
    }, 100);
  }

  // Event listeners for search
  searchInput.addEventListener('input', filterAndSortProducts);

// Replace the quantity button click handler in quick-order.js with this version:

document.addEventListener('click', function(e) {
  console.log('Click detected on:', e.target.className, e.target);
  
  if (e.target.classList.contains('qty-btn')) {
    console.log('Quantity button clicked!');
    const input = e.target.parentNode.querySelector('.quantity-input');
    const row = e.target.closest('.product-row');
    const action = e.target.dataset.action;
    const currentValue = parseInt(input.value) || 1; // Default to 1 if empty
    const max = parseInt(input.max) || 999;
    const min = parseInt(input.min) || 1; // Set minimum to 1
    
    // Get variant select to check inventory policy
    const variantSelect = row.querySelector('.variant-select');
    let inventoryPolicy = 'deny';
    
    if (variantSelect) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      inventoryPolicy = selectedOption.dataset.inventoryPolicy || 'deny';
    }
    
    console.log('Quantity click details:', {
      action,
      currentValue,
      min,
      max,
      inventoryPolicy,
      inputDisabled: input.disabled,
      buttonDisabled: e.target.disabled,
      pointerEvents: getComputedStyle(e.target).pointerEvents,
      cursor: getComputedStyle(e.target).cursor
    });
    
    // Don't process if input is disabled (only for true out-of-stock, not backorder)
    if (input.disabled) {
      console.log('Input is disabled, skipping');
      return;
    }
    
    let newValue = currentValue;
    
    if (action === 'increase') {
      // For inventory_policy = 'continue', allow unlimited increase
      if (inventoryPolicy === 'continue') {
        newValue = currentValue + 1;
      } else if (currentValue < max) {
        newValue = currentValue + 1;
      }
    } else if (action === 'decrease' && currentValue > min) {
      // Only decrease if above minimum (1)
      newValue = currentValue - 1;
    }
    
    console.log('Value change:', currentValue, '->', newValue);
    
    // Only update if value actually changed
    if (newValue !== currentValue) {
      input.value = newValue;
      
      // Create and dispatch input event to trigger subtotal update
      const inputEvent = new Event('input', {
        bubbles: true,
        cancelable: true,
      });
      input.dispatchEvent(inputEvent);
      console.log('Input event dispatched');
    }
    
    // Update button state after quantity change
    checkProductAvailability(row);
  } else {
    console.log('Click was not on qty-btn');
  }
});

  // Enhanced individual add to cart buttons
// Replace the individual add to cart button click handler in quick-order.js with this version:

document.addEventListener('click', function(e) {
  if (e.target.classList.contains('individual-add-btn')) {
    const button = e.target;
    const row = button.closest('.product-row');
    const variantSelect = row.querySelector('.variant-select');
    const quantityInput = row.querySelector('.quantity-input');
    
    const variantId = variantSelect ? variantSelect.value : button.dataset.variantId;
    const quantity = parseInt(quantityInput.value) || 0;
    
    if (quantity <= 0) {
      alert('Please enter a quantity greater than 0');
      return;
    }
    
    const originalText = button.textContent;
    
    button.textContent = 'Adding...';
    button.disabled = true;
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      button.textContent = 'Added!';
      button.classList.add('added');
      
      // Reset quantity to 1 after successful add
      quantityInput.value = 1;
      quantityInput.dispatchEvent(new Event('input'));
      
      // Update cart drawer/counter using the openCartDrawer function defined later
      if (typeof openCartDrawer === 'function') {
        openCartDrawer(false);
      } else {
        // Fallback: trigger cart refresh event directly
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          fetch(`${window.themeVariables.routes.cartUrl}.js`, {cache: 'reload'})
            .then(response => response.json())
            .then(cartData => {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: cartData }
              }));
            });
        }
      }
      
      setTimeout(() => {
        // Always just show 'Add' for available items
        button.textContent = 'Add';
        button.classList.remove('added');
        // Check availability again to set proper button state
        checkProductAvailability(row);
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('Error adding product to cart');
      button.textContent = originalText;
      checkProductAvailability(row);
    });
  }
});

// Replace the variant selection change handler in quick-order.js with this version:

document.addEventListener('change', function(e) {
  if (e.target.classList.contains('variant-select')) {
    const select = e.target;
    const row = select.closest('.product-row');
    const selectedOption = select.options[select.selectedIndex];
    const newVariantId = select.value;
    const newPrice = selectedOption.dataset.price;
    const newStock = selectedOption.dataset.stock;
    const inventoryPolicy = selectedOption.dataset.inventoryPolicy || 'deny';
    const maxQuantity = selectedOption.dataset.maxQuantity || '999';
    
    console.log('Variant changed to:', newVariantId, 'Price:', newPrice, 'Stock:', newStock, 'Policy:', inventoryPolicy, 'Max:', maxQuantity);
    
    // Update price display
    const priceElement = row.querySelector('.price');
    if (priceElement && newPrice) {
      priceElement.textContent = (parseInt(newPrice) / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }
    
    // Update compare price
    const comparePriceElement = row.querySelector('.compare-price');
    const newComparePrice = selectedOption.dataset.comparePrice;
    if (comparePriceElement) {
      if (newComparePrice && parseInt(newComparePrice) > parseInt(newPrice)) {
        comparePriceElement.textContent = (parseInt(newComparePrice) / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
        comparePriceElement.style.display = '';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
    
    // Update stock info and availability
    const stockElement = row.querySelector('.stock-info');
    const stockBadge = row.querySelector('.stock-badge');
    if (stockElement && stockBadge && newStock !== undefined) {
      const stockQuantity = parseInt(newStock);
      
      console.log('Variant change - Stock update:', {
        variantId: newVariantId,
        stockQuantity,
        inventoryPolicy,
        selectedOptionData: selectedOption.dataset
      });
      
      // Check if truly out of stock (no stock AND policy is deny)
      const isTrulyOutOfStock = stockQuantity <= 0 && inventoryPolicy !== 'continue';
      
      if (isTrulyOutOfStock) {
        console.log('Setting as out of stock for variant:', newVariantId);
        stockBadge.className = 'stock-badge out-of-stock';
        stockBadge.textContent = 'Out of Stock';
        stockElement.textContent = 'Not available';
      } else {
        // Everything else shows as available
        console.log('Setting as available for variant:', newVariantId);
        stockBadge.className = 'stock-badge in-stock';
        stockBadge.textContent = 'Available';
        
        if (stockQuantity > 0) {
          if (stockQuantity <= 5) {
            stockElement.innerHTML = `<span class="low-stock">${stockQuantity} left</span>`;
          } else {
            stockElement.textContent = `${stockQuantity} in stock`;
          }
        } else {
          stockElement.textContent = 'In stock';
        }
      }
      
      console.log('Final stock badge classes:', stockBadge.className);
    }
    
    // Update quantity input data attributes
    const quantityInput = row.querySelector('.quantity-input');
    if (quantityInput) {
      // Set max based on inventory policy
      if (inventoryPolicy === 'continue') {
        quantityInput.max = 999; // No limit for backorder items
      } else {
        quantityInput.max = newStock || 999;
      }
      
      quantityInput.dataset.price = newPrice;
      quantityInput.dataset.variantId = newVariantId;
      quantityInput.dataset.maxQuantity = quantityInput.max;
      
      console.log('Updated quantity input max to:', quantityInput.max);
    }
    
    // Update subtotal element's data-variant-id to match new variant
    const subtotalElement = row.querySelector('.subtotal');
    if (subtotalElement) {
      subtotalElement.setAttribute('data-variant-id', newVariantId);
      console.log('Updated subtotal element variant ID to:', newVariantId);
    }
    
    // Update add button
    const addButton = row.querySelector('.individual-add-btn');
    if (addButton) {
      addButton.dataset.variantId = newVariantId;
    }
    
    // Update checkbox value to new variant
    const checkbox = row.querySelector('.product-checkbox');
    if (checkbox) {
      checkbox.value = newVariantId;
    }
    
    // Check availability for the new variant
    checkProductAvailability(row);
    
    // Recalculate subtotal with current quantity and new price
    if (quantityInput) {
      const currentQuantity = parseInt(quantityInput.value) || 0;
      if (currentQuantity > 0) {
        // Trigger input event to recalculate subtotal
        const inputEvent = new Event('input', {
          bubbles: true,
          cancelable: true,
        });
        quantityInput.dispatchEvent(inputEvent);
      }
    }
  }
});



  // Enhanced quantity input handling
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('quantity-input')) {
      const row = e.target.closest('.product-row');
      const variantId = e.target.dataset.variantId;
      const price = parseFloat(e.target.dataset.price);
      let quantity = parseInt(e.target.value) || 1; // Default to 1 if empty
      
      // Enforce minimum of 1
      if (quantity < 1) {
        quantity = 1;
        e.target.value = 1;
      }
      
      // Don't process if input is disabled (only for true out-of-stock, not backorder)
      if (e.target.disabled) {
        return;
      }
      
      // Ensure we have valid price and quantity
      if (isNaN(price) || price <= 0) {
        console.warn('Invalid price for variant:', variantId, 'Price:', price);
        return;
      }
      
      const subtotal = price * quantity;
      
      // Find the subtotal element for this specific variant
      const subtotalElement = document.querySelector(`[data-variant-id="${variantId}"].subtotal`);
      if (subtotalElement) {
        subtotalElement.textContent = (subtotal / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
      } else {
        console.warn('Subtotal element not found for variant:', variantId);
      }

      // Don't auto-check checkbox - let user control it manually
      // const checkbox = row.querySelector('.product-checkbox');
      // Checkbox state is now user-controlled for bulk operations
      
      // Check product availability and update button state
      checkProductAvailability(row);
      
      // Update totals
      // updateTotalValue();
     
    }
  });

  // // Bulk operations
  // clearAllBtn.addEventListener('click', function() {
  //   // Uncheck all checkboxes
  //   document.querySelectorAll('.product-checkbox').forEach(cb => cb.checked = false);
    
  //   // Reset all quantities to 1 (but don't auto-check boxes)
  //   document.querySelectorAll('.quantity-input').forEach(input => {
  //     input.value = 1; // Set to 1 instead of 0
  //     input.dispatchEvent(new Event('input'));
  //   });
    
  //   // Update all button states after clearing
  //   document.querySelectorAll('.product-row').forEach(row => {
  //     checkProductAvailability(row);
  //   });
    
  //   // Update counters
  //   updateSelectedCount();
  // });

  // Add checkbox change listener to update selected count
  // document.addEventListener('change', function(e) {
  //   if (e.target.classList.contains('product-checkbox')) {
  //     updateSelectedCount();
  //   }
  // });

  // Update total value calculation
  // function updateTotalValue() {
  //   let total = 0;
  //   document.querySelectorAll('.quantity-input').forEach(input => {
  //     const quantity = parseInt(input.value) || 0;
  //     const price = parseFloat(input.dataset.price) || 0;
  //     total += (quantity * price);
  //   });
    
  //   totalValueSpan.textContent = (total / 100).toLocaleString('en-US', {
  //     style: 'currency',
  //     currency: 'USD'
  //   });
  // }

  // // Update selected count
  // function updateSelectedCount() {
  //   const selectedItems = document.querySelectorAll('.product-checkbox:checked').length;
  //   selectedCountSpan.textContent = `${selectedItems} items selected`;
  // }

  // // Bulk add to cart
  // bulkForm.addEventListener('submit', function(e) {
  //   e.preventDefault();
    
  //   const selectedItems = [];
  //   document.querySelectorAll('.product-checkbox:checked').forEach(checkbox => {
  //     const row = checkbox.closest('.product-row');
  //     const quantityInput = row.querySelector('.quantity-input');
  //     const quantity = parseInt(quantityInput.value) || 1; // Use current quantity value
      
  //     if (quantity >= 1) { // Minimum quantity check
  //       selectedItems.push({
  //         id: checkbox.value,
  //         quantity: quantity
  //       });
  //     }
  //   });

  //   if (selectedItems.length === 0) {
  //     alert('Please select at least one product to add to cart.');
  //     return;
  //   }

  //   addSelectedBtn.textContent = 'Adding...';
  //   addSelectedBtn.disabled = true;

  //   const promises = selectedItems.map(item => 
  //     fetch('/cart/add.js', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(item)
  //     })
  //   );

  //   Promise.all(promises)
  //     .then(() => {
  //       // Update cart drawer/counter and open it
  //       openCartDrawer(true);
        
  //       // Uncheck all checkboxes after successful bulk add
  //       document.querySelectorAll('.product-checkbox:checked').forEach(cb => {
  //         cb.checked = false;
  //       });
        
  //       // Update selected count
  //       updateSelectedCount();
  //     })
  //     .catch(error => {
  //       console.error('Error adding to cart:', error);
  //       alert('Some items could not be added to cart. Please try again.');
  //     })
  //     .finally(() => {
  //       addSelectedBtn.textContent = 'Add Selected to Cart';
  //       addSelectedBtn.disabled = false;
  //     });
  // });



  // Manual fix function for debugging - you can call this in console
  window.debugQuickOrder = {
    fixRow: function(rowIndex) {
      const rows = document.querySelectorAll('.product-row');
      if (rows[rowIndex]) {
        console.log(`Manually fixing row ${rowIndex + 1}`);
        checkProductAvailability(rows[rowIndex]);
      }
    },
    fixAllRows: function() {
      console.log('Manually fixing all rows');
      document.querySelectorAll('.product-row').forEach((row, index) => {
        console.log(`Fixing row ${index + 1}`);
        checkProductAvailability(row);
      });
    },
    forceEnableBackorder: function(rowIndex) {
      const rows = document.querySelectorAll('.product-row');
      if (rows[rowIndex]) {
        const row = rows[rowIndex];
        const quantityInput = row.querySelector('.quantity-input');
        const addButton = row.querySelector('.individual-add-btn');
        const qtyButtons = row.querySelectorAll('.qty-btn');
        
        console.log(`Force enabling backorder for row ${rowIndex + 1}`);
        
        // Force enable all controls
        quantityInput.disabled = false;
        quantityInput.style.pointerEvents = 'auto';
        quantityInput.style.cursor = 'pointer';
        
        addButton.classList.add('backorder');
        addButton.textContent = 'Add to Backorder';
        
        row.classList.add('backorder');
        row.classList.remove('out-of-stock');
        
        qtyButtons.forEach(btn => {
          btn.disabled = false;
          btn.style.pointerEvents = 'auto';
          btn.style.cursor = 'pointer';
          btn.style.opacity = '1';
        });
        
        console.log('Forced state:', {
          quantityInputDisabled: quantityInput.disabled,
          quantityButtonsDisabled: Array.from(qtyButtons).map(btn => ({
            disabled: btn.disabled,
            pointerEvents: btn.style.pointerEvents,
            cursor: btn.style.cursor
          }))
        });
      }
    },
    testQuantityClick: function(rowIndex) {
      const rows = document.querySelectorAll('.product-row');
      if (rows[rowIndex]) {
        const plusBtn = rows[rowIndex].querySelector('.qty-plus');
        if (plusBtn) {
          console.log('Testing plus button click...');
          plusBtn.click();
        }
      }
    },
    inspectRow: function(rowIndex) {
      const rows = document.querySelectorAll('.product-row');
      if (rows[rowIndex]) {
        const row = rows[rowIndex];
        const quantityInput = row.querySelector('.quantity-input');
        const qtyButtons = row.querySelectorAll('.qty-btn');
        const plusBtn = row.querySelector('.qty-plus');
        const minusBtn = row.querySelector('.qty-minus');
        
        console.log(`Inspecting row ${rowIndex + 1}:`);
        console.log('Row classes:', row.className);
        console.log('Quantity input:', {
          disabled: quantityInput.disabled,
          value: quantityInput.value,
          pointerEvents: getComputedStyle(quantityInput).pointerEvents,
          cursor: getComputedStyle(quantityInput).cursor
        });
        
        qtyButtons.forEach((btn, i) => {
          const action = btn.dataset.action || 'unknown';
          console.log(`${action} button:`, {
            disabled: btn.disabled,
            className: btn.className,
            pointerEvents: getComputedStyle(btn).pointerEvents,
            cursor: getComputedStyle(btn).cursor,
            opacity: getComputedStyle(btn).opacity,
            zIndex: getComputedStyle(btn).zIndex,
            position: getComputedStyle(btn).position
          });
        });
        
        // Test if clicks are being blocked
        if (plusBtn) {
          console.log('Elements at plus button position:');
          const rect = plusBtn.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;
          const elementAtPoint = document.elementFromPoint(centerX, centerY);
          console.log('Element at button center:', elementAtPoint);
          console.log('Is it the button itself?', elementAtPoint === plusBtn);
        }
      }
    }
  };

  // Initialize the page
  initializeProductRows();
  filterAndSortProducts();
});